import React, { useState, useEffect } from "react";
import ErrorPage from '../common/ErrorPage';

const ErrorMessage = props => {

    return <React.Fragment>
        <ErrorPage heading="We are having trouble loading your estimate right now" bannerAlignment="left">
            <div className="text-left">Please call our Pre-Registration department to access your estimates at <a href={"tel:" + props.customerServicePhone} className="phone-link">{props.customerServicePhone}</a>.</div>
        </ErrorPage>
    </React.Fragment>;
}

export default ErrorMessage;